/**
 * Stamped.io product rating cache & thumbnail stars.
 * Config: window.dbodhiStampedConfig (theme-js-config.liquid).
 */
(function () {
  'use strict';

  if (window.__dbodhiStampedRatingsInit) return;
  window.__dbodhiStampedRatingsInit = true;

  const stampedConfig = window.dbodhiStampedConfig || {};
  const API_BASE = stampedConfig.apiBase || 'https://stamped.io/api/widget/reviews';
  const API_KEY = stampedConfig.apiKey || '';
  const STORE_URL = stampedConfig.storeUrl || '';
  const CACHE_HOURS = Number(stampedConfig.cacheHours) || 6;
  const TAKE = 30;
  const CACHE_KEY = 'dbodhi:product-rating';
  const CACHE_TTL_MS = CACHE_HOURS * 60 * 60 * 1000;

  let lastRatingMap = null;
  let fetchPromise = null;

  function now() {
    return Date.now();
  }

  function readCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.expiresAt || now() > parsed.expiresAt) return null;
      return parsed.data || null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          expiresAt: now() + CACHE_TTL_MS,
          data: data,
        })
      );
    } catch (error) {
      // Ignore localStorage write failures.
    }
  }

  function buildUrl(page) {
    const params = new URLSearchParams({
      take: String(TAKE),
      page: String(page),
      storeUrl: STORE_URL,
      apiKey: API_KEY,
    });
    return API_BASE + '?' + params.toString();
  }

  function toProductRatingMap(reviews) {
    const aggregates = {};
    reviews.forEach(function (review) {
      if (!review || typeof review.productId === 'undefined') return;
      const productId = String(review.productId);
      const rating = Number(review.reviewRating);
      if (!rating || rating < 0) return;
      if (!aggregates[productId]) {
        aggregates[productId] = { sum: 0, count: 0 };
      }
      aggregates[productId].sum += rating;
      aggregates[productId].count += 1;
    });

    const result = {};
    Object.keys(aggregates).forEach(function (productId) {
      const item = aggregates[productId];
      if (!item.count) return;
      result[productId] = {
        average: item.sum / item.count,
        total: item.count,
      };
    });
    return result;
  }

  function getRoundedStarCount(average) {
    const value = Number(average) || 0;
    const integerPart = Math.floor(value);
    const decimalPart = value - integerPart;
    const rounded = decimalPart > 0.5 ? integerPart + 1 : integerPart;
    return Math.max(1, Math.min(5, rounded));
  }

  function buildStarsMarkup(average) {
    const filledCount = getRoundedStarCount(average);
    const emptyCount = 5 - filledCount;
    const filledSvg =
      '<svg viewBox="0 0 16 14" class="Icons__StyledSvg-sc-14cbjh3-0 iZKrHP starFilled" fill="none" aria-hidden="true"><path d="M7.85079 0L9.62568 5.04236H15.3693L10.7226 8.1587L12.4975 13.2011L7.85079 10.0847L3.20407 13.2011L4.97896 8.1587L0.332234 5.04236H6.0759L7.85079 0Z" fill="#262525"></path></svg>';
    const emptySvg =
      '<svg viewBox="0 0 16 14" class="Icons__StyledSvg-sc-14cbjh3-0 iZKrHP starEmpty" fill="none" aria-hidden="true"><path d="M8.09493 1.5059L9.39819 5.20837L9.51575 5.54236H9.86982H13.9703L10.6883 7.74344L10.3665 7.95925L10.4951 8.32472L11.7704 11.9476L8.37343 9.66945L8.09493 9.48268L7.81644 9.66945L4.41948 11.9476L5.69473 8.32472L5.82338 7.95925L5.50159 7.74344L2.2196 5.54236H6.32004H6.67411L6.79168 5.20837L8.09493 1.5059Z" stroke="#262525"></path></svg>';
    return filledSvg.repeat(filledCount) + emptySvg.repeat(emptyCount);
  }

  function renderProductRatings(ratingMap) {
    const widgets = document.querySelectorAll('.product-thumbnail__stamped-widget[data-stamped-product-id]');
    widgets.forEach(function (widget) {
      const productId = widget.getAttribute('data-stamped-product-id');
      if (!productId) return;

      const rating = ratingMap && ratingMap[productId];
      const starsEl = widget.querySelector('[data-stamped-rating-stars]');

      if (!rating || !rating.total) {
        widget.style.display = 'none';
        return;
      }

      widget.style.display = '';
      if (starsEl) starsEl.innerHTML = buildStarsMarkup(rating.average);
    });
  }

  function fetchAllRatings() {
    return fetch(buildUrl(1))
      .then(function (res) {
        return res.json();
      })
      .then(function (firstPage) {
        const firstData = (firstPage && firstPage.data) || [];
        const totalAll = Number(firstPage && firstPage.totalAll) || firstData.length;
        const totalPages = Math.max(1, Math.ceil(totalAll / TAKE));
        const requests = [];

        for (let page = 2; page <= totalPages; page += 1) {
          requests.push(
            fetch(buildUrl(page))
              .then(function (res) {
                return res.json();
              })
              .then(function (payload) {
                return (payload && payload.data) || [];
              })
              .catch(function () {
                return [];
              })
          );
        }

        return Promise.all(requests).then(function (restPages) {
          let allReviews = firstData.slice();
          restPages.forEach(function (pageReviews) {
            if (Array.isArray(pageReviews) && pageReviews.length) {
              allReviews = allReviews.concat(pageReviews);
            }
          });
          return toProductRatingMap(allReviews);
        });
      });
  }

  function init() {
    if (lastRatingMap) {
      renderProductRatings(lastRatingMap);
      return Promise.resolve(lastRatingMap);
    }

    const cached = readCache();
    if (cached) {
      lastRatingMap = cached;
      renderProductRatings(cached);
      return Promise.resolve(cached);
    }

    if (fetchPromise) return fetchPromise;

    fetchPromise = fetchAllRatings()
      .then(function (ratingMap) {
        lastRatingMap = ratingMap;
        writeCache(ratingMap);
        renderProductRatings(ratingMap);
        return ratingMap;
      })
      .catch(function () {
        renderProductRatings({});
        return {};
      })
      .finally(function () {
        fetchPromise = null;
      });

    return fetchPromise;
  }

  function renderFromCache() {
    const map = lastRatingMap || readCache();
    if (!map) return false;
    lastRatingMap = map;
    renderProductRatings(map);
    return true;
  }

  window.dbodhiStampedRatings = {
    init: init,
    render: renderProductRatings,
    renderFromCache: renderFromCache,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
